import * as React from "react";
import styled from "styled-components";
import trim from "lodash/trim";
import { useTranslation } from "react-i18next";
import { Col, Row, Button, ButtonToolbar } from "components/bootstrap";
import { DocumentTitle, PageHeader, Spinner, LinkContainer } from "components/common";
import DocsHelper from "util/DocsHelper";
import ReportContents from "report/report-history-page/ReportContents";
import ReportRoutes from "report/ReportRoutes";
import LicenseCheck from "license/LicenseCheck";
import { LICENSE_SUBJECTS } from "license/constants";
import useParams from "routing/useParams";
import Icon from "components/common/Icon";
import useReportSummary from "report/report-history-page/useReportSummary";
import usePermissions from "hooks/usePermissions";
import ReportHistoryList from "./ReportHistoryList";
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;
const ReportHistorySubNav = ({
  reportId,
  editAllowed,
  readAllowed
}) => {
  const { t } = useTranslation("enterprise_report");
  return /* @__PURE__ */ React.createElement(ButtonToolbar, null, readAllowed && /* @__PURE__ */ React.createElement(LinkContainer, { to: ReportRoutes.EDIT.overview(reportId) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, editAllowed ? t("report_history_page.edit_configuration") : t("report_history_page.view_configuration"))));
};
const ReportHistoryPage = () => {
  const { t } = useTranslation("enterprise_report");
  const { isPermitted } = usePermissions();
  const { reportId } = useParams();
  const { data: report, isInitialLoading } = useReportSummary(reportId, true);
  const editAllowed = isPermitted(`report:update:${reportId}`);
  const readAllowed = isPermitted(`report:read:${reportId}`);
  const description = !(report == null ? void 0 : report.description) || trim(report.description) === "" ? /* @__PURE__ */ React.createElement("i", null, t("report_history_page.no_description")) : /* @__PURE__ */ React.createElement("span", null, report.description);
  if (isInitialLoading || !report) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: t("report_history_page.loading") });
  }
  const pageTitle = /* @__PURE__ */ React.createElement(HeaderContainer, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: ReportRoutes.OVERVIEW }, /* @__PURE__ */ React.createElement(Button, { bsSize: "small" }, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_back" }), " ", t("report_history_page.back"))), /* @__PURE__ */ React.createElement("h1", null, report.title));
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("report_history_page.archive_title", { title: report.title }) }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: pageTitle,
      actions: /* @__PURE__ */ React.createElement(ReportHistorySubNav, { reportId: report.id, editAllowed, readAllowed }),
      documentationLink: {
        title: t("report_history_page.documentation_link"),
        path: DocsHelper.PAGES.REPORTING
      }
    },
    description
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ReportContents, { report })), /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ReportHistoryList, { report, editAllowed }))));
};
const ReportHistoryPageWrapper = () => /* @__PURE__ */ React.createElement(LicenseCheck, { licenseSubject: LICENSE_SUBJECTS.report, bsStyle: "danger", displayWarningContainer: true, hideChildren: true }, /* @__PURE__ */ React.createElement(ReportHistoryPage, null));
export default ReportHistoryPageWrapper;
